/*
 * HomeFixer360 - Reusable Navigation Component
 * Copyright (c) 2025 Guy T. Dunn Sr. / Idea Guy Brands Incorporated
 * All Rights Reserved.
 */

import React from 'react';
import { Button } from '../ui/button';

const Navigation = () => {
  return (
    <nav className="relative z-10 flex items-center justify-between px-6 py-4 bg-white/80 backdrop-blur-md border-b border-gray-200/20">
      <div 
        className="text-2xl font-bold text-blue-600 cursor-pointer"
        onClick={() => window.location.href = '/'}
      >
        HomeFixer360
      </div>
      <div className="hidden md:flex items-center space-x-8">
        <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors">Home</a>
        <a href="/#benefits" className="text-gray-700 hover:text-blue-600 transition-colors">Benefits</a>
        <a href="/#pricing" className="text-gray-700 hover:text-blue-600 transition-colors">Pricing</a>
        <a href="/tutorial" className="text-gray-700 hover:text-blue-600 transition-colors">Tutorial</a>
        <a href="/partner-program" className="text-gray-700 hover:text-blue-600 transition-colors">Partner Program</a>
        <a href="/login" className="text-gray-700 hover:text-blue-600 transition-colors">Login</a>
        <Button 
          onClick={() => window.location.href = '/dashboard'}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          Get Started
        </Button>
      </div>
    </nav>
  );
};

export default Navigation;
